var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[(_vm.label)?_c('div',{staticClass:"v-label mb-1"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('date-picker',{attrs:{"value":_vm.datetime,"type":_vm.pickerType,"showSecond":false,"minute-options":[0, 15, 30, 45],"format":_vm.format},on:{"input":_vm.setDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }